import React from "react";
import Functions, {Particles} from './functions';
import axios from 'axios';

export default class Emojis extends Functions {

	#emoji_address;
	#emoji_animations;

	constructor(props) {
		super(props);
		this.process = this.process.bind(this);
		this.paint = this.paint.bind(this);
		this.gap = 2;
		//this.mouseX = 0;
		//this.mouseY = 0;
	
		this.emoji_animations = [];
	}




	//---- Process the incoming emojis / emotes
	async process(data, image, timeframe, controller) {
		//console.log(data);

		let time = 0;

		for( let n in data.index ) {
			

			//---- Replace all path x, y positions to screen co-ordiantes
			const regex = new RegExp(/(?:\d{1}\.\d{1,30}|\d{1}),(?:\d{1}\.\d{1,30}|\d{1})/, 'ig');
			const array = [...data.index[n].path.matchAll(regex)];
			for( let i in array ) {
				let u = array[i][0].split(',');
				let x = parseInt(u[0]*window.innerWidth);
				let y = parseInt(u[1]*window.innerHeight);
				if( u[0] <= 1 ) {
					let z = `${x},${y}`;
					data.index[n].path = data.index[n].path.replaceAll(array[i][0], z);
				}
			}
			


			//---- Explosions
			//console.log(data.index[n]);
			if( data.index[n].explode === true ) {
				let _canvas = document.createElement('canvas');
				_canvas.width = image.width;
				_canvas.height = image.height;
				let _ctx = _canvas.getContext('2d');
				_ctx.drawImage( image.data[0] || image.data, 0, 0, image.width, image.height );
				let imgdata = _ctx.getImageData(0, 0, image.width, image.height).data;
				
				
				let particles = [];
				for( let y = 0; y < _canvas.height; y += this.gap ) {
					for( let x = 0; x < _canvas.width; x += this.gap ) {
						const index = (y * _canvas.width + x) * 4;
						if( imgdata[index+3] > 0 ) {
							const red = imgdata[index];
							const green = imgdata[index+1];
							const blue = imgdata[index+2];
							const color = `rgb(${red},${green},${blue})`;
							particles.push(new Particles(x, y, color));
						}
					}
				}
				//console.log(particles);
				data.index[n].particles = particles;
			}


			//---- Sleeps


			//---- Shuffles


			//---- Paths
			data.index[n].pathEl = document.createElementNS("http://www.w3.org/2000/svg", "path");
			data.index[n].pathEl.setAttribute("d", data.index[n].path);
			data.index[n].path = new Path2D(data.index[n].path);

			data.index[n].begin = timeframe + data.index[n].begin + time;
			data.index[n].canvas = 0;
			data.index[n].canvasdate = Date.now();

			time += data.index[n].begin - timeframe;
		}

		
		

		//console.log(data.path, array);



		//const selection = 'Firework';

		//---- Load Explosions
		
		/*
		if( data.explode ) {

			let _canvas = document.createElement('canvas');
			_canvas.width = image.width;
			_canvas.height = image.height;
			let _ctx = _canvas.getContext('2d');
			_ctx.drawImage( image.data[0] || image.data, 0, 0, image.width, image.height );
			let imgdata = _ctx.getImageData(0, 0, image.width, image.height).data;
			
			
			let particles = [];
			for( let y = 0; y < _canvas.height; y += this.gap ) {
				for( let x = 0; x < _canvas.width; x += this.gap ) {
					const index = (y * _canvas.width + x) * 4;
					if( imgdata[index+3] > 0 ) {
						const red = imgdata[index];
						const green = imgdata[index+1];
						const blue = imgdata[index+2];
						const color = `rgb(${red},${green},${blue})`;
						particles.push(new Particles(x, y, color));
					}
				}
			}
			data.explode = {
				particles,
				duration: 10000
			}

			/*metrics[selection].explode.data = imgdata.data;
			metrics[selection].explode.width = imgdata.width;
			metrics[selection].explode.height = imgdata.height;
			*
		}
	*/










		//const random = Math.floor(Math.random() * 3)+2;

		/*const pathData = `M20 ${20*random}
			s ${20*random},${80*random} ${40*random},${80*random}
			Q ${25*random},${25*random} ${40*random},${50*random}
			t ${30*random},0 ${30*random},0 ${30*random},0 ${30*random},0 ${30*random},0
			M10,30 A20,20 0,0,1 50,30 A20,20 0,0,1 90,30 Q90,60 50,90 Q10,60 10,30 z`;*/


			/*
		const pathEl = document.createElementNS("http://www.w3.org/2000/svg", "path");
		pathEl.setAttribute("d", data.index[i].path);
		const totalLength = pathEl.getTotalLength();
		const path = new Path2D(data.index[i].path);
		*/

		/*return {
			emoji: data.data,
			canvas: 0,
			canvasdate: Date.now(),
			animation: 0,
			path,
			pathEl,
			duration: data.duration,
			maxDuration: (Date.now() + 30000),
			begin: timeframe+data.begin,
			repeat: data.repeat,
			explode: data.explode,
		};*/

		return data;
	}






	async animatedEmojis() {
		try {
			if( this.emoji_animations.length === 0 ) {
				const x = await axios({
					method: 'post',
					url: `https://api.ultrastream.io/v3/template/emojis`,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
					},
					timeout: 5000
				});
				this.emoji_address = x.data.address;
				this.emoji_animations = x.data.emojis;
			}
		} catch(error) {
			console.log(error);
		}
	}


	

	
	
	//---- Paint to screen
	async paint(ctx, content, emojisemotes, timeframe) {

		ctx.strokeStyle = "blue";
		let update = false;


		for( let i in emojisemotes ) {

			let ref = emojisemotes[i].index[emojisemotes[i].state];
			if( !ref ) continue;

			if( content ) {
				if( content[emojisemotes[i].data]?.data ) {

					ctx.stroke(ref.path);
						
					//---- Path co-ordination
					const delta = ((timeframe - ref.begin) % ref.duration) / ref.duration;
					const distance = delta * ref.pathEl.getTotalLength();
					//if( parseInt(i) === 0) console.log(distance)
					const pt = ref.pathEl.getPointAtLength(distance);

					if( ref.explode === true ) {
						//---- Explosions
						ref.particles.forEach(particles => {
							particles.explode(content[emojisemotes[i].data].width/2, content[emojisemotes[i].data].height/2);
							particles.draw(ctx, pt.x - content[emojisemotes[i].data].width/2, pt.y - content[emojisemotes[i].data].height/2);
						});

					} else {

						if( Array.isArray(content[emojisemotes[i].data].data) === true ) {

							//---- Animated images
							ctx.drawImage( content[emojisemotes[i].data].data[ref.canvas], pt.x - content[emojisemotes[i].data].width/2, pt.y - content[emojisemotes[i].data].height/2, content[emojisemotes[i].data].width, content[emojisemotes[i].data].height );
							if( Date.now() > ref.canvasdate + Math.floor(1000/20) ) {
								ref.canvas++;
								ref.canvasdate = Date.now();
								if( ref.canvas >= content[emojisemotes[i].data].data.length ) ref.canvas = 0;
								update = true;
							}

						} else {

							//---- Single images	
							ctx.drawImage( content[emojisemotes[i].data].data, pt.x - content[emojisemotes[i].data].width/2, pt.y - content[emojisemotes[i].data].height/2, content[emojisemotes[i].data].width, content[emojisemotes[i].data].height );
						
							
							
						}
						

					}


					if( timeframe > ref.begin+ref.duration - 40 ) {

						//---- Increment onto next level
						//if( emojisemotes[i].index.length > 1 ) {
							
							//console.log(emojisemotes[i].repeat);
							if( emojisemotes[i].repeat === true ) {
								//emojisemotes[i].state = 0;
								ref.begin = timeframe;

								if( Date.now() > emojisemotes[i].ctime + 20000 ) {
									emojisemotes[i].state = emojisemotes[i].state + 1;
								}

							} else {
								emojisemotes[i].state = emojisemotes[i].state + 1;
							}
	
								/*let time = timeframe;
								for( let j in emojisemotes[i].index ) {
									//emojisemotes[i].index[j].begin = time;
									//time += emojisemotes[i].index[j].duration;

									
								}*/
						//}
						
						/*
						//if( parseInt(i) === 1 ) console.log(emojisemotes[i].state);

						//if( emojisemotes[i].state < emojisemotes[i].index.length - 1 ) {
							if( emojisemotes[i].state === emojisemotes[i].index.length - 1 ) {
								//if( parseInt(i) === 1 ) console.log(emojisemotes[i].state);
								if( emojisemotes[i].repeat === true ) emojisemotes[i].state = 0;
	
								let time = timeframe;
								for( let j in emojisemotes[i].index ) {
									emojisemotes[i].index[j].begin = time;
									time += emojisemotes[i].index[j].duration;

									
								}
	
								//update = true;
							} else {
								emojisemotes[i].state = emojisemotes[i].state + 1;
							}

*/
							

							update = true;
						//}
					}
				}
			}


			/*
			if( emojisemotes[i].maxDuration === 0 ) emojisemotes[i].maxDuration = Date.now() + 25000;
      if( content ) {
        if( content[emojisemotes[i].emoji]?.data ) {
					ctx.stroke(emojisemotes[i].path);

					const delta = ((timeframe - emojisemotes[i].begin) % emojisemotes[i].duration) / emojisemotes[i].duration;
					const distance = delta * emojisemotes[i].pathEl.getTotalLength();
					const pt = emojisemotes[i].pathEl.getPointAtLength(distance);

					
					if( !emojisemotes[i].repeat && (timeframe - emojisemotes[i].begin) >= emojisemotes[i].duration ) {
						if( emojisemotes[i].explode ) {
							if( (timeframe - emojisemotes[i].begin) < emojisemotes[i].explode.duration ) {
								const enddistance = emojisemotes[i].pathEl.getTotalLength();
								const endpt = emojisemotes[i].pathEl.getPointAtLength(enddistance);
								emojisemotes[i].explode.particles.forEach(particles => {
									particles.explode(content[emojisemotes[i].emoji].width/2, content[emojisemotes[i].emoji].height/2);
									particles.draw(ctx, endpt.x - content[emojisemotes[i].emoji].width/2, endpt.y - content[emojisemotes[i].emoji].height/2);
								});
							}
						}
						//---- Do nothing more
						continue;
					}
					

					
					console.log(content[emojisemotes[i].emoji]);
          //if( content[emojis[i].emoji].data.length === 1 ) {
            ctx.drawImage( content[emojisemotes[i].emoji].data, pt.x - content[emojisemotes[i].emoji].width/2, pt.y - content[emojisemotes[i].emoji].height/2, content[emojisemotes[i].emoji].width, content[emojisemotes[i].emoji].height );
					
						//ctx.drawImage( content[emojis[i].emoji].data, parseInt(i)*150+100, 100, content[emojis[i].emoji].width, content[emojis[i].emoji].height );

          /*} else {
            ctx.drawImage( content[emojis[i].emoji].data[emojis[i].canvas], pt.x - content[emojis[i].emoji].width/2, pt.y - content[emojis[i].emoji].height/2, content[emojis[i].emoji].width, content[emojis[i].emoji].height );
            if( Date.now() > emojis[i].canvasdate + Math.floor(1000/20) ) {
              emojis[i].canvas++;
              emojis[i].canvasdate = Date.now();
              if( emojis[i].canvas >= content[emojis[i].emoji].data.length ) emojis[i].canvas = 0;
              update = true;
            }
          }*
        } else {
        }
      }*/
      
    }
		return update?emojisemotes:false;
	}
}
